import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import config from "@/config";
import get from "lodash/get";
import { DO_ROUTE } from "./config/constants/action-types";
import { getParameterByName } from "./utils";

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

const rutasConTracking = new Set([
  "oferta",
  "landingQR",
  "paso1",
  "paso2",
  "paso3",
  "paso4",
  "loadingVeridas",
  "biometriaOK",
  "entrega",
  "resumen",
  "contratos",
  "gracias"
]);

// Agregamos la atribución solo al flujo de solicitud de préstamos personales.
// No redirigimos desde un guard.
// Así push/replace mantienen sus promesas y callbacks originales.
for (const method of ["push", "replace"]) {
  const navigate = router[method].bind(router);
  router[method] = (location, onComplete, onAbort) => {
    const resolved = router.resolve(location);
    if (
      _BBVA_MOTOR !== "ofertaPersonales" ||
      !rutasConTracking.has(resolved.route.name)
    ) {
      return navigate(location, onComplete, onAbort);
    }
    const target = resolved.location;
    const query = { ...target.query };
    for (const key of ["tracking_id", "cid"]) {
      if (Object.prototype.hasOwnProperty.call(query, key)) continue;
      const value = get(
        router.currentRoute,
        ["query", key],
        getParameterByName(key)
      );
      if (typeof value === "string" && value.trim()) {
        query[key] = value;
      }
    }
    // No copiamos hr_datos ni otros parámetros de la pantalla anterior.
    return navigate({ ...target, query }, onComplete, onAbort);
  };
}

/* Con esto actualizo el store con el paso actual para que los watchers lo sepan */
router.beforeEach((to, from, next) => {
  to.meta.config = config.getPasoProperties(to.name);
  to.meta.name = to.name;
  store.dispatch(DO_ROUTE, to);

  const rutasSinSimulacion = [
    "consulta",
    "calculadoraValorStep1",
    "calculadoraValorStep2",
    "calculadoraIngresosStep1",
    "calculadoraIngresosStep2",
    "calculadoraIngresosStep3",
    "asesoramiento",
    "mensaje",
    "mensajeVeridas",
    "prescriptoresStep1",
    "prescriptoresStep2",
    "graciasPrescriptores"
  ];

  // si simulacion esta en false
  // y la ruta ingresada no se encuentra en la lista de rutas permitidas sin simulacion
  // redirijo a la ruta raiz
  if (
    !get(store, "state.simulacion", false) &&
    !rutasSinSimulacion.includes(to.name) &&
    PRODUCTION
  ) {
    router.replace({ path: "/", redirect: "/" });
  }
  next();
});

export default router;
